import { Button } from 'antd';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useRouter } from 'next/router';
import { FC, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation } from '../../helpers/formatters';
import { renderMarkdown } from '../../helpers/utils';
import { Patientportal_PortalFacilityMsg } from '../../src/generated/graphql';
import styles from './facility-selection.module.scss';

interface FacilityDescriptionProps {
  facility: Maybe<Patientportal_PortalFacilityMsg> | undefined;
}

export const FacilityDescription: FC<FacilityDescriptionProps> = ({ facility }) => {
  const { formatMessage } = useIntl();
  const router = useRouter();
  const textRef = useRef<HTMLDivElement>(null);

  const [showFullText, setShowFullText] = useState<boolean>(false);

  const [isOverflowing, setIsOverflowing] = useState(false);

  const locale = router.locale;
  const longDescription = extractTranslation(facility?.longDescription, locale);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [longDescription]);

  console.log('isOverflowing', isOverflowing);

  return (
    <div>
      <div
        ref={textRef}
        className={`${
          showFullText ? styles.clinicDescriptionLongUnlimited : styles.clinicDescriptionLong
        } ant-list-item-meta-description description`}
        onClick={() => {
          if (!showFullText) {
            setShowFullText(true);
          }
        }}
      >
        {renderMarkdown(longDescription) ||
          formatMessage({ id: 'facility-selection.no-description' })}
      </div>
      {isOverflowing && (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            style={{ padding: 0 }}
            type={'link'}
            onClick={() => setShowFullText((prev) => !prev)}
          >
            {formatMessage({
              id: showFullText ? 'action.show-less' : 'action.show-more',
            })}
          </Button>
        </div>
      )}
    </div>
  );
};
